import { useEffect, useRef, useState } from "react";
import { useRouteMatch, NavLink } from "react-router-dom";
import { motion } from "framer-motion";

import "./CreatorHome.scss";

import CardLink from "../generalComponents/CardLink";

import { images } from "../../constants";
import CardProposalNotification from "../generalComponents/CardProposalNotification";
import { useDispatch, useSelector } from "react-redux";
import { getColleges } from "../../actions/college";
import { getCourses } from "../../actions/course";
import { getStudents } from "../../actions/student";
import { getProposals } from "../../actions/proposal";
import AlertPopUp from "../generalComponents/AlertPopUp";

const CreatorHome = () => {
  const [width, setWidth] = useState(0);

  const carousel = useRef();
  // const notifList = useRef();
  const { url } = useRouteMatch();

  // const maxNotifications = 3;    //<- Esto es para mostrar solo 3 notifications  (configurar peticiones que sean 10 minimo desde server)

  useEffect(() => {
    const fullWidth = carousel.current.scrollWidth;
    const offSetScreen = carousel.current.offsetWidth;
    setWidth(fullWidth - offSetScreen);
  }, []);

  const dispatch = useDispatch();

  const { colleges } = useSelector((state) => state.colleges);
  const { courses } = useSelector((state) => state.courses);
  const { students } = useSelector((state) => state.students);
  const { proposals } = useSelector((state) => state.proposals);

  useEffect(() => {
    dispatch(getColleges());
    dispatch(getCourses());
    dispatch(getStudents());
    dispatch(getProposals());

    //eslint-disable-next-line
  }, []);

  const collegeCount = colleges.length;
  const courseCount = courses.length;
  const studentCount = students.length;
  const proposalCount = proposals.length;

  const cards = [
    {
      name: "Colleges",
      icon: images.IconCollege,
      link: `${url}/colleges`,
      count: collegeCount,
      bg: "college-card-bg",
    },
    {
      name: "Courses",
      icon: images.IconCourse,
      link: `${url}/courses`,
      count: courseCount,
      bg: "course-card-bg",
    },
    {
      name: "Students",
      icon: images.IconProfile,
      link: `${url}/students`,
      count: studentCount,
      bg: "student-card-bg",
    },
    {
      name: "Proposal",
      icon: images.IconProposal,
      link: `${url}/proposals`,
      count: proposalCount,
      bg: "proposal-card-bg",
    },
  ];

  return (
    <div className="app__home">
      <div className="menu-cards">
        <h2 className="text-title title-home">Dashboard</h2>

        <motion.div
          ref={carousel}
          className="carousel"
          whileTap={{ cursor: "grabbing" }}
        >
          <motion.div
            drag="x"
            dragConstraints={{ right: 0, left: -width }}
            className="carousel-inner"
          >
            {cards?.map((card) => (
              <motion.div className="item" key={card.name}>
                <NavLink to={`${card.link}`}>
                  <CardLink {...card} />
                </NavLink>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </div>

      <div className="notifications-section">
        <div className="proposal-notification">
          <h2 className="text-title title-home second-title">
            Proposals Notifications
          </h2>

          <div className="notification">
            <div className="notification__inner">
              {/* CONSIDERAR ESTO PERO NO SERIA UNA BUENA IDEA */}
              {/* {notfications?.map(
                (quote, index) =>
                  index + 1 <= maxNotifications && (
                    <motion.div key={index} className="notification__item">
                      <CardProposalNotification {...quote} />
                    </motion.div>
                  )
              )} */}

              {proposals.length === 0 ? (
                <AlertPopUp msg={`Proposals not found`} type={400} />
              ) : (
                <>
                  {proposals?.map((proposal) => (
                    <div
                      key={proposal._id}
                      className="notification__item"
                    >
                      <CardProposalNotification proposal={proposal} />
                    </div>
                  ))}
                </>
              )}
            </div>
            {/* <p className="link">see all</p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatorHome;
